import { i18n } from '@/boot/i18n';
import InteractionService from '@/services/interaction';
import ErrorHandler from '@/tools/errorHandler';
import * as types from './mutationTypes';

export default {
  initState({ commit, dispatch }) {
    commit(types.SET_INTERACTIONS, []);
    commit(types.SET_TOTAL_INTERACTIONS, 0);
    dispatch('metadata/setMetadatas', [], { root: true });
  },
  clearState({ commit, dispatch }) {
    dispatch('clearInteractions');
    dispatch('metadata/clearMetadatas', null, { root: true });
    commit(types.CLEAR_FILTER_INTERACTIONS);
  },
  setInteractionSuccess({ commit }, { interactions, total }) {
    commit(types.SET_INTERACTIONS, interactions);
    commit(types.SET_TOTAL_INTERACTIONS, total);
  },
  setInteractionCategoriesSuccess({ commit }, categories) {
    commit(types.SET_INTERACTION_CATEGORIES, categories);
  },
  clearInteractionCategoriesState({ commit, dispatch }) {
    commit(types.CLEAR_INTERACTION_CATEGORIES);
    dispatch('category/clearCategoriesTree', null, { root: true });
  },
  setFilterInteractions({ commit }, filter) {
    commit(types.SET_FILTER_INTERACTIONS, filter);
  },
  async getAll({ dispatch, rootState }, filter) {
    try {
      const response = await InteractionService.getAll(rootState.organization.organization.uuid, filter);
      dispatch('setInteractionSuccess', {
        interactions: response.data.data.interactions ?? [],
        total: response.data.data.total_rows ?? 0,
      });
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async getAllAvailable({ dispatch }, pagination) {
    try {
      if (!pagination) {
        pagination = {};
      }
      pagination.available = true;
      await dispatch('getAll', pagination);
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async getInteractionCategories({ rootState, dispatch }, interactionUUID) {
    try {
      const response = await InteractionService.getInteractionCategories(
        rootState.organization.organization.uuid,
        interactionUUID,
      );
      if (response.data.data) {
        dispatch('setInteractionCategoriesSuccess', response.data.data);
      }
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async delete({ rootState, dispatch }, interactionUUID) {
    try {
      await InteractionService.delete(rootState.organization.organization.uuid, interactionUUID);
      dispatch('ui/showToastSuccess', i18n.t('interaction.messages.delete_success'), { root: true });
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  updateInteractionCategory({ rootState }, interactionCategory) {
    return InteractionService.updateInteractionCategory(rootState.organization.organization.uuid, interactionCategory);
  },
  deleteInteractionCategory({ rootState }, { interactionUUID, categoryUUID }) {
    return InteractionService.deleteInteractionCategory(
      rootState.organization.organization.uuid,
      interactionUUID,
      categoryUUID,
    );
  },
  clearInteractions({ commit }) {
    commit(types.CLEAR_INTERACTIONS);
    commit(types.CLEAR_TOTAL_INTERACTIONS);
  },
  setInteractions({ commit }, interactions) {
    commit(types.SET_INTERACTIONS, interactions);
  },
};
